import { Component } from '@nicolas-riciotti/light2';
import getPosition from '../../helpers/getPosition';
import BezierEasing from '../../helpers/BezierEasing.js'
import Tween from '../../helpers/Tween.js';
import Lenis from '../../helpers/Lenis'

export default class BlockValues extends Component {

    created() {
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.siteSettingsMotionChange = this.siteSettingsMotionChange.bind(this);
        this.onScroll = this.onScroll.bind(this); 
        this._scroll   = 0;
        this.lastIndex = -2;
    }
    siteSettingsMotionChange(event) {
        this.stopped = ('off' === event.detail);
    }

    resize() {
        this.pos = getPosition( this );
    }
    attached() {
        
        document.addEventListener('site_settings_motion', this.siteSettingsMotionChange, false);

        this.$titles  = this.querySelectorAll('[title]');
        this.$texts   = this.querySelectorAll('[text]');
        this.$shapes  = this.querySelectorAll('[shape]');

        this.$titles?.forEach((el,i) => {
            el.setAttribute('data-index', i);
            el?.addEventListener('mouseenter', this.onMouseEnter, false);
            el?.addEventListener('mouseleave', this.onMouseLeave, false);
        });

        this.updateIndex(-1);
        Lenis?.on?.('scroll', this.onScroll)
        this.resize();
    }
    onMouseEnter(e) {
        const index    = Number( e.currentTarget.getAttribute('data-index') );
        this.updateIndex(index);
    }
    onMouseLeave(e) {
        this.updateIndex(0);
    }

    onScroll(e) {
        this._scroll = e.animatedScroll ;
        const localScroll = this.pos.top + window.innerHeight - this._scroll
        if (localScroll > window.innerHeight) {
            this.updateIndex(-1);
        }
        else {
            this.updateIndex( Math.floor((localScroll) / window.innerHeight) * -1 );
        }
    }

    updateIndex(index) {

        if (index == this.lastIndex) {
            return;
        }

        index = Math.min(this.$titles.length-1, index);

        this.lastIndex = index;

        this.$titles?.forEach((titleEl,titleIndex) => {
            titleEl.classList[titleIndex == index ? 'add' : 'remove']('is-active');
        });
        this.$texts?.forEach((textEl,textIndex) => {
            textEl.classList[textIndex == index ? 'add' : 'remove']('is-active');
            textEl.classList[textIndex == index ? 'add' : 'remove']('in-view');
        });

        this.$shapes?.forEach((shapeEl,shapeIndex) => {

            if (shapeIndex == index) {

                shapeEl.classList.add('is-active');

                const titlePos = getPosition( this.$titles[index], this );
                const textPos  = getPosition( this.$texts[index],  this );
                if (this.pos) {
                    const localScroll = this.pos.top  - this._scroll;
                    titlePos.top -= localScroll * -1;
                    textPos.top -= localScroll * -1;
                }
                const mode = shapeEl.getAttribute('mode');
                if (mode == 'connect') {
                    shapeEl.style.left    = (titlePos.left + titlePos.width ) + 'px';
                    shapeEl.style.top     = (textPos.top  )  + 'px';
                    const w = textPos.left - (titlePos.left + titlePos.width);
                    shapeEl.style.width  = w + 'px';
                }
                if (mode == 'start') {
                    const shapeW = titlePos.height
                    shapeEl.style.left    = (titlePos.left - shapeW ) + 'px';
                    shapeEl.style.top     = (titlePos.top  )  + 'px';
                    shapeEl.style.width   = shapeW + 'px';
                }
                if (mode == 'circled') {
                    shapeEl.style.width   = titlePos.width + 'px';
                    const shapeH = shapeEl.clientHeight;
                    shapeEl.style.left    = (titlePos.left ) + 'px';
                    shapeEl.style.top     = (titlePos.top + titlePos.height/2 - shapeH/2  )  + 'px';
                }
                if (mode == 'underline') {
                    shapeEl.style.left    = (titlePos.left ) + 'px';
                    shapeEl.style.top     = (titlePos.top + titlePos.height )  + 'px';
                    shapeEl.style.width   = titlePos.width * 1.2 + 'px';
                }

                const dashLength = shapeEl.getAttribute('dash-length');
                shapeEl.tween?.destroy();
                shapeEl.tween = Tween({e:0}, {
                    to: {e:1},
                    easing:    [0, 0, 1, 1],
                    duration:  this.stopped ? 0.01 : 700,
                    step: e => {
                        shapeEl.style.strokeDashoffset = (1 - e) * dashLength;
                    }
                });

            }
            else {
                shapeEl.tween?.destroy();
                shapeEl.classList.remove('is-active');
            }
        });

    }
   
}

customElements.define('block-values', BlockValues);